import { Cartao } from '@/componentes/ui'

/**
 * Passo a passo de instalação, por plataforma.
 *
 * Extraído de `PaginaInstalar` para ser reaproveitado em dois lugares:
 * o gate obrigatório do primeiro acesso, e uma referência sempre
 * disponível no Perfil — para quem quer reinstalar num aparelho novo,
 * ou mostrar o passo a passo para outra pessoa, sem precisar passar
 * pelo fluxo de bloqueio de novo.
 */

export function PassosIOS() {
  const passos = [
    { texto: 'Toque no botão Compartilhar, na barra de baixo do Safari.' },
    { texto: 'Role e escolha "Adicionar à Tela de Início".' },
    { texto: 'Toque em "Adicionar", no canto superior direito.' },
    { texto: 'Feche o Safari e abra o app pelo ícone Viver.' },
  ]

  return (
    <Cartao>
      <h3 className="mb-4 font-titulo text-base font-semibold">No iPhone, em 4 passos</h3>
      <ol className="flex flex-col gap-4">
        {passos.map((passo, indice) => (
          <li key={passo.texto} className="flex items-start gap-3">
            <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-coral font-titulo text-sm font-bold text-white">
              {indice + 1}
            </span>
            <span className="text-[15px] leading-snug">{passo.texto}</span>
          </li>
        ))}
      </ol>

      <p className="mt-4 rounded-xl bg-[var(--borda)] p-3 text-xs leading-relaxed text-[var(--tinta-suave)]">
        Precisa ser pelo <strong>Safari</strong>. O Chrome no iPhone não consegue adicionar o app à
        tela de início.
      </p>
    </Cartao>
  )
}

/**
 * Versão estática, sem o botão de instalação ao vivo — a referência no
 * Perfil descreve o passo a passo de outro aparelho, não deste; o
 * evento `beforeinstallprompt` só existe para o dispositivo atual.
 */
export function PassosAndroidEstatico() {
  const passos = [
    'Toque nos três pontinhos, no canto superior direito do Chrome.',
    'Escolha "Instalar app" ou "Adicionar à tela inicial".',
    'Confirme e abra o app pelo ícone Viver.',
  ]

  return (
    <Cartao>
      <h3 className="mb-3 font-titulo text-base font-semibold">No Android</h3>
      <ol className="flex flex-col gap-4">
        {passos.map((texto, indice) => (
          <li key={texto} className="flex items-start gap-3">
            <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-coral font-titulo text-sm font-bold text-white">
              {indice + 1}
            </span>
            <span className="text-[15px] leading-snug">{texto}</span>
          </li>
        ))}
      </ol>
    </Cartao>
  )
}

export function AvisoDesktop() {
  return (
    <Cartao>
      <h3 className="mb-2 font-titulo text-base font-semibold">Abra no celular</h3>
      <p className="text-[15px] leading-relaxed text-[var(--tinta-suave)]">
        O Projeto Viver foi feito para o celular — é onde os lembretes do dia funcionam. Abra este
        mesmo endereço no seu telefone para instalar.
      </p>
    </Cartao>
  )
}
